import { styled } from "@mui/material";
import React, { memo, useCallback } from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { debounce } from "lodash";

type types = Omit<TextFieldProps<"outlined">, "variant">;
export interface MxInputFieldProps extends types {
  name?: string;
  starticon?: React.ReactNode;
  endIcon?: React.ReactNode;
  inputRef?: any;
  backgroundColor?: string;
  onSearch?: (value: string) => void;
  id?: string;
}

const MxInputField = (props: MxInputFieldProps) => {
  const {
    starticon,
    endIcon,
    backgroundColor = "transparent",
    onSearch,
    onChange,
    onBlur,
    id,
    name,
    value,
    ...rest
  } = props;

  const handleSearch = useCallback(
    debounce((value: string) => {
      if (onSearch) {
        onSearch(value);
      }
    }, 500),
    [onSearch]
  );

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(event);
      }
      if (onSearch) {
        handleSearch(event.target.value);
      }
    },
    [onChange, onSearch, handleSearch]
  );

  const handleBlur = useCallback(() => {
    if (onBlur) {
      onBlur({
        target: {
          id: id ?? "",
          name: name ?? "",
          value
        }
      } as any);
    }
  }, [onBlur, id, name, value]);

  return (
    <CustomInput
      {...rest}
      {...(name ? { name } : {})}
      {...(id ? { id } : {})}
      {...(value !== undefined ? { value } : {})}
      size="small"
      variant="outlined"
      fullWidth
      onChange={handleChange}
      autoComplete="off"
      data-testid={`${id || name}-input-field`}
      InputProps={{
        startAdornment: starticon,
        endAdornment: endIcon,
        inputProps: {
          "data-testid": `${id || name}-input-field-input`
        }
      }}
      backgroundColor={backgroundColor}
      onBlur={handleBlur}
    />
  );
};

export default memo(MxInputField);

const CustomInput = styled(TextField, {
  shouldForwardProp: prop => prop !== "backgroundColor"
})<{ backgroundColor: string }>(({ theme, backgroundColor }) => ({}));
